<div class="lookup-cell">
  <div class="lookup-content">
    <!-- Lookup button -->
    <button mat-icon-button
            class="lookup-btn"
            (click)="openLookupDialog()"
            [matTooltip]="buttonLabel || 'Open lookup'">
      <mat-icon>more_horiz</mat-icon>
    </button>
  </div>

  <!-- Optional label below -->
  <div class="lookup-label" *ngIf="buttonLabel">
    {{ buttonLabel }}
  </div>
</div>
